export default __webpack_public_path__ + "static/patreon-f29f92881c68b2dc8d2dae54541376f9.png";